'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

exports.default = function (url) {
    if (!authPrefsPromise) {
        authPrefsPromise = new _promise2.default(function (resolve, reject) {
            if (!url) {
                reject('Navigation auth preferences url is not configured');
            } else {
                _jquery2.default.ajax({
                    url: url,
                    xhrFields: {
                        withCredentials: true
                    },
                    crossDomain: true,
                    cache: false
                }).done(function (data) {
                    resolve(data);
                }).fail(function () {
                    reject("Can't resolve all necessary information from secure server! URL: " + url);
                });
            }
        });
    }

    return authPrefsPromise;
};

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var authPrefsPromise = null; /**
                              * @author: Serhii Atiahin [serhii.atiahin@racingpost.com]
                              */


//////////////////
// WEBPACK FOOTER
// ./~/rp-navigation/lib/navigation/authPrefsLoader.js
// module id = 2677
// module chunks = 1